import { render, staticRenderFns } from "./Sinistre.vue?vue&type=template&id=5042716e&scoped=true&"
import script from "./Sinistre.vue?vue&type=script&lang=js&"
export * from "./Sinistre.vue?vue&type=script&lang=js&"
import style0 from "./Sinistre.vue?vue&type=style&index=0&id=5042716e&prod&lang=scss&"
import style1 from "./Sinistre.vue?vue&type=style&index=1&id=5042716e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042716e",
  null
  
)

export default component.exports